<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'apt-caws'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <legend>APT CAWs</legend>
      <p class="text-nowrap">
        <b>{{rowCount}}</b> {{(rowCount == 1 ? 'record' : 'records')}} found
      </p>

      <grid-pager [actionName]="'/admin/apt-caws'" [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></grid-pager>

      <table class="table table-sm table-align-middle">
        <thead>
          <tr class="headers-row">
            <th style="width: 4rem;"></th>
            <th style="width: 1rem;">Id</th>
            <th>Name</th>
            <th>Client</th>
          </tr>
          <tr class="filters-row">
            <td>
              <button type="button" class="btn btn-sm btn-block btn-secondary text-nowrap" (click)="clearFilters()">
                <i class="fa fa-times"></i>
                Clear
              </button>
            </td>
            <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="idFilter" (change)="updateDataGrid()" /></td>
            <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="nameFilter" (change)="updateDataGrid()" /></td>
            <td><input type="text" class="form-control form-control-sm" placeholder="Filter by..." [(ngModel)]="clientFilter" (change)="updateDataGrid()" /></td>
          </tr>
        </thead>
        <tbody>
          @if (activeAptCaws.length == 0) {
            <tr>
              <td colspan="4">
                <span class="d-block p-2 text-center">
                  <i class="fa fa-ban text-danger"></i>
                  No data to display&hellip;
                </span>
              </td>
            </tr>
          }
          @for (aptCaws of activeAptCaws; track aptCaws) {
            <tr>
              <td></td>
              <td class="px-3 font-weight-bold">{{aptCaws.id}}</td>
              <td>{{aptCaws.name}}</td>
              <td>{{aptCaws.client ? aptCaws.client.name : '---'}}</td>
            </tr>
          }
        </tbody>
      </table>

      <grid-pager [actionName]="'/admin/apt-caws'" [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></grid-pager>
    </fieldset>
  </div>
</div>
